import { X } from 'lucide-react';
import { C } from '../../theme.js';
import { Button, IconButton, TextInput } from '../../components/Primitives.jsx';

// Generic row of two inputs (key, value) for renames / lookup maps
export function KVRows({ entries, onChange, keyPlaceholder = 'key', valuePlaceholder = 'value' }) {
  const rows = entries.length ? entries : [['', '']];
  const update = (i, idx, v) => {
    const next = rows.map((r, j) => j === i ? (idx === 0 ? [v, r[1]] : [r[0], v]) : r);
    onChange(next.filter(([k, v]) => k !== '' || v !== ''));
  };
  const remove = (i) => onChange(rows.filter((_, j) => j !== i));
  const add = () => onChange([...rows, ['', '']]);
  return (
    <>
      {rows.map(([k, v], i) => (
        <div key={i} style={{ display: 'flex', gap: 6, marginBottom: 6 }}>
          <TextInput value={k} onChange={(x) => update(i, 0, x)} placeholder={keyPlaceholder} mono />
          <span style={{ color: C.fg5, alignSelf: 'center', fontSize: '.8rem' }}>→</span>
          <TextInput value={v} onChange={(x) => update(i, 1, x)} placeholder={valuePlaceholder} mono />
          <IconButton title="Remove" onClick={() => remove(i)}><X size={14} /></IconButton>
        </div>
      ))}
      <Button kind="ghost" size="sm" onClick={add} icon="＋">Add row</Button>
    </>
  );
}
